import { Component, OnInit } from '@angular/core';
import { ReservationState, TicketReservationService } from '../../services/ticket-reservation.service';

@Component({
  selector: 'app-enea-header',
  templateUrl: './enea-header.component.html',
  styleUrls: ['./enea-header.component.css']
})
export class EneaHeaderComponent implements OnInit {

  ReservationState = ReservationState;

  constructor(public ticketReservationService: TicketReservationService) { }

  ngOnInit(): void {
  }

}
